(function () {
	"use strict";

	var module = angular.module("uwAgenda.global");

	/* service for different helper functions */
	module.factory("HelperService", [
		"$rootScope",
		"$filter",
		"$translate",
		"$q",
		"$uibModal",
		"SharedAgendaService",
		"TaskStateEnum",
		"TaskState",
		"RoleType",
		'AppConfig',
		'$window',
		function (
			$rootScope,
			$filter,
			$translate,
			$q,
			$uibModal,
			SharedAgendaService,
			TaskStateEnum,
			TaskState,
			RoleType,
			AppConfig,
			$window
		) {
			var service = {
				// data
				data: {
					contactinfotypes: [], // list of possible contact-info-types (UserContactInfoType-Objects)
					phonemasks: [], // list of phonemasks for validation
					countries: [], // list of countries
					countriesWithCallingCodes: [], // list of countries with calling-codes
				},

				time: time,
				date: date,
				frontendDate: frontendDate,
				backendDate: backendDate,
				isoDateWithoutZoneFromMoment: isoDateWithoutZoneFromMoment,
				utcDate: utcDate,
				translateRoles: translateRoles,
				block: block,
				unblock: unblock,
				unblockAll: unblockAll,
				enoughCharactersForFilterCheck: enoughCharactersForFilterCheck,
				paginate: paginate,
				generateTaskStateArray: generateTaskStateArray,
				generateDurationIntervals: generateDurationIntervals,
				prepareUserSearchResult: prepareUserSearchResult,
				capitalize: capitalize,
				validateMobile: validateMobile,
				validatePhone: validatePhone,
				validateEmail: validateEmail,
				validateNationalNumber: validateNationalNumber,
				validateIbanNumber: validateIbanNumber,
				getLocalDateFormat: getLocalDateFormat,
				noPatientRoles: noPatientRoles,
				getMonthDateRange: getMonthDateRange,
				backendDateWithoutMilliseconds: backendDateWithoutMilliseconds,
				deactivatingConfirmationModal: deactivatingConfirmationModal,

				truncate: truncate,
				htmlToPlainText: htmlToPlainText,
				removeLineBreaksFromString: removeLineBreaksFromString,

				copyTextToClipboard: copyTextToClipboard,

				getMedirisUrl: getMedirisUrl,
				getEyeFileUrl: getEyeFileUrl,
				getEyeFileUrlNew: getEyeFileUrlNew,
				closeQuickSidebar: closeQuickSidebar,
				deDuplicateArray: deDuplicateArray,

				showInfoModal: showInfoModal,
				GenerateRedirectionUrl: GenerateRedirectionUrl
			};

			return service;

			function GenerateRedirectionUrl (authUrl, clientId, redirectUri, responseType) {
				const nonce = generateNonce();
				$window.location.href = `${authUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=openid&acr_values=LOA_3&nonce=${nonce}&brand=MyOrganizer`;
			}
			
			function generateNonce(length = 32) {
				const array = new Uint8Array(length);
				window.crypto.getRandomValues(array);
				return btoa(String.fromCharCode.apply(null, array))
					.replace(/\+/g, '-')
					.replace(/\//g, '_')
					.replace(/=+$/, '');
			}

			function showInfoModal(title, body) {
				let modalInstance = $uibModal.open({
					backdrop: "static",
					keyboard: false,
					animation: true,
					templateUrl: "/app/global/templates/rf-global-info-modal.template.html",
					controller: "GlobalInfoController",
					controllerAs: "viewModel",
					size: "md",
					resolve: {
						title: () => title,
						body: () => body
					}
				});

				return modalInstance.result.then(
					() => {
					},
					() => {
					}
				);
			}

			// Return Iso-Date Without TimeZone from Moment-Date-Object
			function isoDateWithoutZoneFromMoment(momentDate) {
				return momentDate ? momentDate.format("YYYY-MM-DDTHH:mm:ss.SSS") : null;
			}

			function deDuplicateArray(array) {
				var a = array.concat();
				for (var i = 0; i < a.length; ++i) {
					for (var j = i + 1; j < a.length; ++j) {
						if (a[i] === a[j])
							a.splice(j--, 1);
					}
				}

				return a;
			}

			// array of no-patient-roles
			function noPatientRoles() {
				return [
					RoleType.MainUser.value,
					RoleType.SubuserAdmin.value,
					RoleType.RingfoonOperatorAdmin.value,
					RoleType.RingfoonOperatorRestricted.value,
					RoleType.RingfoonAdmin.value,
				];
			}

			// validate mobile number by phonemasks
			function validateMobile(value, countryPrefix) {
				if (countryPrefix == undefined) { // == to check for null and undefined
					return true;
				}
				
				// do not validate, if value is empty
				if (
					value === null ||
					typeof value === "undefined" ||
					value.length === 0 ||
					!service.data.phonemasks ||
					service.data.phonemasks.length === 0
				) {
					return true;
				}
				// right masks for country
				let masksForCountry = $filter("filter")(
					service.data.phonemasks,
					{prefix: countryPrefix},
					true
				);
				if (masksForCountry.length === 0) {
					return true;
				}
				//Remove symbols in the input value before checking for regex
				let cleanedValue = value.replace(/\D/g, '');
				
				// check if any of the phonemasks for the selected country match the value
				for (const element of masksForCountry) {
					let regex = new RegExp(element.regex);
					if (cleanedValue.match(regex)) {
						return true;
					}
				}

				return false;
			} // validateMobile

			function validatePhone(value, countryPrefix) {
				// do not validate, if value is empty
				if (
					value === null ||
					typeof value === "undefined" ||
					value.length === 0 ||
					!service.data.phonemasks ||
					service.data.phonemasks.length === 0
				) {
					return true;
				}

        if (countryPrefix == undefined // == to check for null and undefined
          || !validateMobile(value, countryPrefix)) {
          //Remove symbols in the input value before checking for regex
          let cleanedValue = value.replace(/\D/g, '');

          let regex = /^[\d().\s\-/\\]*$/;
          return !!value.match(regex) && !!cleanedValue.match(/^\d{3,10}$/);
        }
        
        return false;
			}

			function enoughCharactersForFilterCheck(text) {
				let words = text.trim().split(' ');
				let valid = true;
				if (words.length > 1) {
					// check words
					for (let i = 0; i < words.length; i++) {
						// for words, the minimal number of characters is 2
						valid = validateWordLength(words[i], 2);
						if (!valid) {
							return false;
						}
					}
				} else {
					valid = validateWordLength(text, 3);
				}
				return valid;
			}

			function validateWordLength(word, minimalLetters) {
				if (word) {
					if (word.match(/^[0-9]*$/)) {
						return word.length > 3;
					} else {
						return word.length >= minimalLetters;
					}
				}
				return false;
			}

			// validate email
			function validateEmail(value) {
				// do not validate, if value is empty
				if (
					value === null ||
					typeof value === "undefined" ||
					value.length === 0
				) {
					return true;
				}

				// valid email regex
				var regex = new RegExp(
					/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
				);
				if (value.match(regex)) {
					return true;
				}

				return false;
			} // validateMobile

			function validateNationalNumber(value) {
				if (!value) {
					return true; // nationalnumber is not required
				}

				let numericRegex = /^\d+$/;
				let valid =
					numericRegex.test(value) &&
					(value.length === 9 || value.length === 11);

				return valid;
			}

			function validateIbanNumber(value) {
				if (!value) {
					return true; // ibannumber is not required
				}

				let numericRegex = /^\d+$/;
				return isValidIBANNumber(value);
			}

			/* capitalize */
			function capitalize(string) {
				if (typeof string === "undefined") {
					return "";
				}
				return string.charAt(0).toUpperCase() + string.slice(1);
			}

			function htmlToPlainText(text) {
				return text ? String(text).replace(/<[^>]+>/gm, "") : "";
			}

			function truncate(str, n) {
				return str.length > n ? str.substr(0, n) + "&hellip;" : str;
			}

			function removeLineBreaksFromString(str) {
				return str ? str.replace(/\r?\n|\r/g, "") : "";
			}

			/* make vm-time for timepicker */
			function time(date) {
				var d = new Date(date);
				// compensate the difference between utc and local time
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setUTCMilliseconds(0);
				d.setUTCSeconds(0);
				return d;
			}

			/* make just date */
			function date(date) {
				var d = new Date(date);
				//reset time
				d.setHours(0);
				d.setMinutes(0);
				d.setSeconds(0);
				d.setMilliseconds(0);
				return d;
			}

			/* make utc date for frontend */
			function utcDate(date) {
				var d = new Date(date);
				var utcDate = new Date(
					d.getUTCFullYear(),
					d.getUTCMonth(),
					d.getUTCDay(),
					d.getUTCHours(),
					d.getUTCMinutes(),
					d.getUTCSeconds()
				);
				return utcDate;
			}

			/* make backend date */
			function backendDate(date) {
				return $filter("date")(date, "yyyy-MM-ddTHH:mm:ss.sss");
			}

			/* make backend date without milliseconds */
			function backendDateWithoutMilliseconds(date) {
				return $filter("date")(date, "yyyy-MM-ddTHH:mm:ss");
			}

			/* date for frontend */
			function frontendDate(date) {
				return $filter("RfGlobalLongDateFilter")(date);
			}

			/* localized format string for date and optional time */
			function getLocalDateFormat(withTime) {
				var format = moment().localeData().longDateFormat("L"); // day, month, year
				if (withTime) {
					format += " " + moment().localeData().longDateFormat("LTS"); // hour, minute, second
				}

				return format;
			}

			// returns a promise with an array of the translated roles
			function translateRoles(roles) {
				var promises = [];
				for (var i = 0; i < roles.length; i++) {
					if (roles[i]) {
						var promise = $translate("roletype_" + roles[i].type);
						promises.push(promise);
					}
				}
				return $q.all(promises);
			}

			// block ui
			function block(target) {
				// block modal
				App.blockUI({
					target: target,
					iconOnly: true,
					//    boxed: true,
					//  centerY: true,
					//    animate: true
				});
			}

			// unblock
			function unblock(target) {
				App.unblockUI(target);
			}

			// unblock all
			function unblockAll() {
				App.unblockUI();
			}

			// paginate/calculate new result list
			function paginate(items, currentPage, itemsPerPage) {
				var begin = (currentPage - 1) * itemsPerPage;
				var end = begin + itemsPerPage;

				// return new result list
				return items.slice(begin, end);
			}

			// function for generating array of task-states depending on current user
			function generateTaskStateArray(isToDo, all) {
				// arr of states
				var taskStates = [];

				//// depending on current user -> show correct task-states
				taskStates.push(new TaskState(TaskStateEnum.InProgress)); // always there

				// urgent-to-does -> only in-progress and finished
				if (
					typeof isToDo === "undefined" ||
					isToDo === "false" ||
					isToDo === false
				) {
					// ONLY for daytasks

					// Ringfoon -> follow-up-by-ringfoon
					if ($rootScope.isRingfoon === true || SharedAgendaService.currentUser().isSecretaryLicence === true) {
						taskStates.push(new TaskState(TaskStateEnum.FollowUpByOperator));
						taskStates.push(new TaskState(TaskStateEnum.FollowUpByRingfoon));
					} //if
				} // if

				if (all !== undefined && all === true) {
					taskStates.push(new TaskState(TaskStateEnum.Finished));
				}

				return taskStates;
			}

			function generateDurationIntervals() {
				var interval = SharedAgendaService.data.currentAgenda.interval;
				var maxDuration = SharedAgendaService.data.currentAgenda.maxDuration;

				var durations = [];
				for (var dur = interval; dur <= maxDuration; dur = dur + interval) {
					durations.push(dur);
				}
				return durations;
			}

			// prepare the user search result
			function prepareUserSearchResult(result, detailedContactInfo) {
				if (detailedContactInfo === undefined) {
					detailedContactInfo = false;
				}

				// map detailed array of user-items to grouped-user-list => user with list of contact-infos
				var map = {};
				var list = [];
				var j = 0;
				var length = result.length;
				for (j = 0; j < length; j++) {
					// current user
					var user = result[j];
					var key = "_" + user.id;
					var tmp = map[key]; // this step is NEEDED FOR IE11 :-(
					// if user in list ?
					if (typeof tmp === "undefined") {
						user.contactInfos = [];
						map[key] = user;
					} // if

					// add new contact info to map
					if (user.userContactInfo && user.userContactInfo.id > 0) {
						//sometimes userContactInfo is just a formatted string, other times it's a detailed object
						if (detailedContactInfo) {
							map[key].contactInfos.push(user.userContactInfo);
						} else {
							var contactInfo = user.userContactInfo.caption + " ";

							if (
								user.userContactInfo.prefix &&
								user.userContactInfo.prefix.length > 0
							) {
								contactInfo = contactInfo + user.userContactInfo.prefix + " ";
							}

							contactInfo = contactInfo + user.userContactInfo.value;
							map[key].contactInfos.push(contactInfo);
						}

						// only one of the users/contactinfo-combo has the mainEmail property set, so we have to find that and set it to the user object we used for the key
						if (
							user.mainEmail !== null &&
							typeof user.mainEmail !== "undefined" &&
							(map[key].mainEmail === null ||
								typeof map[key].mainEmail === "undefined")
						) {
							// main email
							map[key].mainEmail = user.mainEmail;
						}
					}
				} // for

				for (var keyValue in map) {
					list.push(map[keyValue]);
				} // for

				return list;
			} // prepareUserSearchResult

			// returns an object with the start and end of the month of the given date
			function getMonthDateRange(date) {
				var startDate = moment(date).startOf("month");
				var endDate = moment(date).endOf("month");

				return {start: startDate.toDate(), end: endDate.toDate()};
			}

			// create modal-instance for confirming deactivate-action
			function deactivatingConfirmationModal() {
				return $uibModal.open({
					backdrop: "static",
					keyboard: false,
					animation: true,
					templateUrl:
						"/app/global/templates/rf-global-item-deactivating-modal.template.html",
					controller: "ItemDeactivatingController",
					controllerAs: "vm",
					size: "xs",
				});
			}

			function fallbackCopyTextToClipboard(text) {
				var textArea = document.createElement("textarea");
				textArea.value = text;

				// Avoid scrolling to bottom
				textArea.style.top = "0";
				textArea.style.left = "0";
				textArea.style.position = "fixed";

				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					var successful = document.execCommand("copy");
				} catch (err) {
					console.error("Fallback copy text to clipboard failed", err);
				}

				document.body.removeChild(textArea);
			}

			function copyTextToClipboard(text) {
				if (!navigator.clipboard) {
					fallbackCopyTextToClipboard(text);
					return;
				}
				navigator.clipboard.writeText(text).then(
					function () {
					},
					function (err) {
						fallbackCopyTextToClipboard(text);
					}
				);
			}

			function getMedirisUrl(
				firstName,
				lastName,
				birthday
			) {
				var url = `${AppConfig.MedirisUrl}/Patients?action=search`;

				if (firstName) {
					url += `&firstname=${firstName.trim()}`;
				}

				if (lastName) {
					url += `&lastname=${lastName.trim()}`;
				}

				if (birthday) {
					var birthDayFormatted = moment(birthday).format("DD-MM-YYYY");
					url += `&birthday=${birthDayFormatted}`;
				}

				return url;
			}

			function getEyeFileUrl(
				firstName,
				lastName,
				birthday,
				phone,
				eyeFileId,
				email
			) {
				let url = `http://ExternalAppDummy?PatName=${lastName.trim()}&PatFirstName=${firstName.trim()}`;
				if (birthday) {
					let birthdayFormatted = moment(birthday).format("YYYY-MM-DD");
					url += `&PatDateOfBirth=${birthdayFormatted}`;
				}

				if (phone) {
					url += `&PatTelNumber=${phone.trim()}`;
				}

				if (email) {
					url += `&PatEmail=${email.trim()}`;
				}

				if (eyeFileId) {
					url += `&PatID=${eyeFileId}`;
				}

				return url;
			}

			function getEyeFileUrlNew(
				firstName,
				lastName,
				birthday,
				phone,
				email,
				uniqueId,
				fileId
			) {
				let url = `http://ExternalAppDummy?PatName=${lastName.trim()}&PatFirstName=${firstName.trim()}`;
				if (birthday) {
					let birthdayFormatted = moment(birthday).format("YYYY-MM-DD");
					url += `&PatDateOfBirth=${birthdayFormatted}`;
				}

				if (phone) {
					url += `&PatTelNumber=${phone.trim()}`;
				}

				if (email) {
					url += `&PatEmail=${email.trim()}`;
				}

				if (uniqueId) {
					url += `&PatIntId=${uniqueId}`;
				}

				if (fileId) {
					url += `&PatExtId=${fileId}`;
				}

				return url;
			}

			function closeQuickSidebar() {
				document.body.classList.toggle('page-quick-sidebar-open', false);
				document.body.style.overflowY = 'auto';

			}

			/*
 * Returns 1 if the IBAN is valid 
 * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
			function isValidIBANNumber(input) {
				var CODE_LENGTHS = {
					AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
					CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
					FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
					HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
					LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
					MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
					RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
					AL: 28, BY: 28, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
					SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
				};
				var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
					code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
					digits;
				// check syntax and length
				if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
					return false;
				}
				// rearrange country code and check digits, and convert chars to ints
				digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
					return letter.charCodeAt(0) - 55;
				});
				// final check
				return mod97(digits) === 1;
			}

			function mod97(string) {
				var checksum = string.slice(0, 2), fragment;
				for (var offset = 2; offset < string.length; offset += 7) {
					fragment = String(checksum) + string.substring(offset, offset + 7);
					checksum = parseInt(fragment, 10) % 97;
				}
				return checksum;
			}
		}
	]);
})();
